var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7803 13.2803C10.4874 13.5732 10.0126 13.5732 9.71967 13.2803L3.71967 7.28033C3.42678 6.98744 3.42678 6.51256 3.71967 6.21967L9.71967 0.21967C10.0126 -0.0732231 10.4874 -0.0732231 10.7803 0.21967C11.0732 0.512563 11.0732 0.987437 10.7803 1.28033L5.31066 6.75L10.7803 12.2197C11.0732 12.5126 11.0732 12.9874 10.7803 13.2803Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftOrange);
export default __webpack_public_path__ + "static/media/ChevronLeftOrange.ebd244412d5528bc765b57c9efd9a365.svg";
export { ForwardRef as ReactComponent };